



















































import Vue from "vue";

export default Vue.extend({
  methods: {
    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
